import { ChangeEvent, ReactNode, useState } from 'react'
import { useTranslation } from 'libs/i18n'
import { useSearchParams } from 'libs/router'
import { FilterField, FiltersPanel, FiltersToggle, SearchInput, Select } from 'shared/components'
import { useFilters } from '../../hooks/useFilters'

const FILTER_PARAMS = ['type', 'payout_requested']

type FiltersSectionProps = {
	actions?: ReactNode
	handleSearch: (data: ChangeEvent<HTMLInputElement>) => void
	handleFilter: ({ id, value }: { id: string; value: string | null }) => void
}

export const FiltersSection = ({ actions, handleSearch, handleFilter }: FiltersSectionProps) => {
	const { t } = useTranslation()
	const [searchParams, setSearchParams] = useSearchParams()
	const filters = useFilters()
	const [isOpen, setIsOpen] = useState(FILTER_PARAMS.some((param) => searchParams.has(param)))
	const [resetKey, setResetKey] = useState(0)

	const clearFilters = () => {
		const params = new URLSearchParams(searchParams)
		FILTER_PARAMS.forEach((param) => params.delete(param))
		params.delete('cursor')
		setSearchParams(params)
		setResetKey((key) => key + 1)
	}

	return (
		<div className="border-b border-border p-4">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-center">
				{actions}
				<SearchInput
					variant="filled"
					className="min-w-0 flex-1"
					label={t('Search users')}
					placeholder={t('Search users...')}
					onChange={handleSearch}
				/>
				<FiltersToggle isOpen={isOpen} onClick={() => setIsOpen((open) => !open)} />
			</div>
			{isOpen && (
				<FiltersPanel key={resetKey} title={t('Filter users')} onClear={clearFilters}>
					{filters.map((filter) => (
						<FilterField key={filter.id} label={filter.label}>
							<Select
								id={filter.id}
								variant="outline"
								placeholder={filter.placeholder}
								options={filter.options}
								defaultValue={filter.options.find(
									(option) => option.value === searchParams.get(filter.id)
								)}
								onChange={(data) => handleFilter({ id: filter.id, value: data?.value || null })}
							/>
						</FilterField>
					))}
				</FiltersPanel>
			)}
		</div>
	)
}
